import { render, staticRenderFns } from "./ImagesLabNewsListView.vue?vue&type=template&id=8825d92e&scoped=true"
import script from "./ImagesLabNewsListView.vue?vue&type=script&lang=js"
export * from "./ImagesLabNewsListView.vue?vue&type=script&lang=js"
import style0 from "./ImagesLabNewsListView.vue?vue&type=style&index=0&id=8825d92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8825d92e",
  null
  
)

export default component.exports